// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max"

/** 11403-部门新增 POST /web/v1/dept/add */
export async function addDept(
  body: API.SwimDeptAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/dept/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11405-部门删除 GET /web/v1/dept/delete/${param0} */
export async function deleteDept(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteDeptParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/dept/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11402-部门详情查询 GET /web/v1/dept/detail/${param0} */
export async function getDeptDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getDeptDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimDeptDetailVo>(
    `/web/v1/dept/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11401-部门列表查询 GET /web/v1/dept/list */
export async function getDeptList(params: { name?: string, status?: number }, options?: { [key: string]: any }) {
  return request<API.YmResultVOListSwimDeptListVo>("/web/v1/dept/list", {
    method: "GET",
    params: { ...params },
    ...(options || {}),
  });
}

/** 11400-分页查询role POST /web/v1/dept/pageList */
export async function webGetSwimDeptPageList(
  body: API.SwimDeptPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimDeptListVo>(
    "/web/v1/dept/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11404-部门修改 POST /web/v1/dept/update */
export async function updateDept(
  body: API.SwimDeptUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/dept/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
